export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "open_content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open Content"])},
        "view_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View results"])},
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading…"])},
        "filter_toggle_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detailed search"])},
        "no_results_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No results. Please change your search filter to get a result."])}
      },
      "de": {
        "open_content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open Content"])},
        "view_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zeige Ergebnisse"])},
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lädt…"])},
        "filter_toggle_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detailsuche"])},
        "no_results_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Treffer. Bitte verändern Sie die Suchfilter, um zu einem Ergebnis zu kommen."])}
      }
    }
  })
}
